import { AddIcon } from "@/components/icons/Icon";
import { Button } from "@/components/ui/button"
import { ReactElement } from "react";


export interface AddButtonProps {
    caption: string;
    onClick: () => void;
    // add spread props to have better control
    [key: string]: any;
}

const AddButton = ({ caption, onClick, ...rest }: AddButtonProps): ReactElement => {
    return (<Button colorPalette="blue" onClick={onClick} {...rest}><AddIcon /> {caption}</Button>)
}

export default AddButton
